import React, {lazy, Suspense} from "react";
import useWithStore from "@/Hooks/useWithStore";
import {useAllStore} from "@/Stores/useAllStore";

const NotificationModal = lazy(() => import('@/Components/Modal/NotificationModal'));
const Cookie = lazy(() => import('@/Pages/All/Cookie'));
const SelectCityModal = lazy(() => import('@/Pages/Header/SelectCityModal'));
const ProfileDrawer = lazy(() => import('@/Pages/Header/ProfileDrawer'));
const SelectSizeModal = lazy(() => import('@/Components/Modal/SelectSizeModal'));
const NotSizeModal = lazy(() => import('@/Components/Modal/NotSizeModal'));
const SuccessAddWaitListModal = lazy(() => import('@/Components/Modal/SuccessAddWaitListModal'));
const FindOutYourSizeModal = lazy(() => import('@/Components/Modal/FindOutYourSizeModal'));
const LoginOrRegistrationModal = lazy(() => import('@/Components/Modal/LoginOrRegistrationModal'));
const ServiceModal = lazy(() => import('@/Pages/All/ServiceModal'));
const Widget = lazy(() => import('@/Pages/All/Widget'));
const BuyOneClickModal = lazy(() => import('@/Components/Modal/BuyOneClickModal'));
const QuickViewModal = lazy(() => import('@/Components/Modal/QuickViewModal'));
const DeliveryInformationModal = lazy(() => import('@/Pages/All/DeliveryInformationModal'));
const ModalError = lazy(() => import('@/Pages/All/ModalError'));
const FindOutPriceModal = lazy(() => import('@/Components/Modal/FindOutPriceModal'));
const CreatingPreOrderModal = lazy(() => import('@/Components/Modal/CreatingPreOrderModal'));
const WheelOfFortuneModal = lazy(() => import('@/Pages/All/WheelOfFortuneModal'));
const WidgetModal = lazy(() => import('@/Components/Modal/WidgetModal'));
const ApplicationDrawer = lazy(() => import('@/Components/Modal/ApplicationDrawer'));
const DiscountFirstOrderModal = lazy(() => import('@/Components/Modal/DiscountFirstOrderModal'));
const SearchModal = lazy(() => import('@/Components/Modal/SearchModal'));
const ModalScanner = lazy(() => import('@/Pages/Site/Search/ModalScanner'));
const SecretSantaDrawer = lazy(() => import('@/Components/Drawer/SecretSantaDrawer'));
const GiftCalendarModal = lazy(() => import('@/Components/Modal/GiftCalendarModal'));

const ModalWindows = (props) => {
    const interactionFlag = useAllStore((state) => state.interactionFlag);

    if (!interactionFlag) return null;

    return (
        <>
            <Suspense><NotificationModal {...props} /></Suspense>
            <Suspense><Cookie {...props} /></Suspense>
            <Suspense><SelectCityModal {...props} /></Suspense>
            <Suspense><Widget {...props} /></Suspense>
            <Suspense><ProfileDrawer {...props} /></Suspense>
            <Suspense><BuyOneClickModal {...props} /></Suspense>
            <Suspense><QuickViewModal {...props} /></Suspense>
            <Suspense><SelectSizeModal {...props} /></Suspense>
            <Suspense><NotSizeModal {...props} /></Suspense>
            <Suspense><SuccessAddWaitListModal {...props} /></Suspense>
            <Suspense><FindOutYourSizeModal {...props} /></Suspense>
            <Suspense><LoginOrRegistrationModal {...props} /></Suspense>
            <Suspense><DeliveryInformationModal {...props} /></Suspense>
            <Suspense><ServiceModal {...props} /></Suspense>
            <Suspense><ModalError {...props} /></Suspense>
            <Suspense><FindOutPriceModal {...props} /></Suspense>
            <Suspense><CreatingPreOrderModal {...props} /></Suspense>
            <Suspense><WheelOfFortuneModal {...props} /></Suspense>
            <Suspense><WidgetModal {...props} /></Suspense>
            <Suspense><ApplicationDrawer {...props} /></Suspense>
            <Suspense><DiscountFirstOrderModal {...props} /></Suspense>
            <Suspense><SearchModal {...props} /></Suspense>
            <Suspense><ModalScanner {...props} /></Suspense>
            <Suspense><SecretSantaDrawer {...props} /></Suspense>
            <Suspense><GiftCalendarModal {...props} /></Suspense>
        </>
    );
};

export default useWithStore(ModalWindows);
